import(/* webpackMode: "eager" */ "/vercel/path0/src/app/catalog/search/page.tsx");
